interface JobLocationPresentation {
  location?: string | null;
  source?: string | null;
}

export const getJobLocationLabel = ({
  location,
  source,
}: JobLocationPresentation): string => {
  const normalizedLocation = typeof location === 'string' ? location.trim() : '';
  if (normalizedLocation) return normalizedLocation;

  return source?.toLowerCase() === 'stagecrew'
    ? 'Location not provided'
    : 'Location not confirmed by source';
};
